import React, { useEffect, useState } from "react";
import axios from "axios";
import { KeyUri } from "../key";

const Offers = () => {
  const [coupons, setCoupons] = useState([]);

  useEffect(() => {
    const fetchCoupons = async () => {
      try {
        const response = await axios.get(`${KeyUri.BACKEND_URI}/get-all-coupon`);
        const activeCoupons = response.data.filter(
          (coupon) =>
            coupon.is_active &&
            new Date(coupon.expiration_date) > new Date()
        );
        setCoupons(activeCoupons.slice(0, 30)); // Show only first 5 valid & active coupons
      } catch (error) {
        console.error("Error fetching coupons:", error);
      }
    };

    fetchCoupons();
  }, []);

  return (
    <div className="py-10 px-4 md:px-12 bg-gray-100 font-lato">
      <h2 className="text-3xl font-bold text-blue-900 mb-10 text-center">
        Latest Offers
      </h2>

      <div className="flex space-x-4 overflow-x-auto scrollbar-hide">
        {coupons.map((coupon) => (
          <div
            key={coupon._id}
            className="min-w-[250px] bg-white border border-blue-100 rounded-lg shadow p-4 flex-shrink-0 snap-start"
          >
            <div className="flex items-center justify-between mb-2">
              <span className="inline-block text-xs bg-yellow-200 text-yellow-800 px-2 py-0.5 rounded-full">
                {coupon.coupon_category || "Offer"}
              </span>
              {coupon.is_single_use && (
                <span className="inline-block text-xs bg-red-100 text-red-600 px-2 py-0.5 rounded-full">
                  Single Use
                </span>
              )}
            </div>

            <h3 className="text-blue-700 font-semibold text-lg mb-1">
              {coupon.coupon_name}
            </h3>

            <p className="text-sm text-gray-700 mb-1">
              Code: <span className="font-mono font-bold">{coupon.coupon_code}</span>
            </p>

            <p className="text-sm text-gray-600 mb-1">
              Discount:{" "}
              {coupon.discount_type === "percentage"
                ? `${coupon.coupon_amount}% off (Max ₹${coupon.max_discount_amount})`
                : `Flat ₹${coupon.coupon_amount} off`}
            </p>

            <p className="text-xs text-gray-500">
              Valid till: {new Date(coupon.expiration_date).toLocaleDateString()}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Offers;
